const querystring = require('querystring');
const makeQueryParamsUtil = require('./makeQueryParamsUtil');

/**
 * Builds an URL for the given search (doctrine.fr/?q=...).
 * This is a utility module also used on the frontend side
 * Please do not insert any specific backend configuration
 */
module.exports = function(search_query) {
  if (!search_query) {
    return null;
  }

  const params = makeQueryParamsUtil(search_query);

  return '/search?' + querystring.stringify(params);
};
